import {
  StrapiActionTypes,
  FetchRequestAction,
  FetchSuccessAction,
  FetchFailureAction,
  StrapiItem,
  AddFailureAction,
  AddSuccessAction,
  AddRequestAction,
  SetLastAddedIdAction,
  DeleteRequestAction,
  DeleteSuccessAction,
  DeleteFailureAction,
  SetLastDocIdAction,
} from '../types/types';

export const fetchData = (modelName: string, filters?: any, pagination?: { page: number; pageSize: number }): FetchRequestAction => {
  let params: Record<string, any> = {};

  if (pagination) {
    params['pagination[page]'] = pagination.page;
    params['pagination[pageSize]'] = pagination.pageSize;
  }

  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (key.startsWith('filters[')) {
        params[key] = value;
      } else {
        params[`filters[${key}]`] = value;
      }
    });
  }

  return {
    type: StrapiActionTypes.FETCH_REQUEST,
    payload: {
      modelName,
      params,
      pagination,
    },
  };
};

export const fetchDataSuccess = (
  modelName: string,
  data: StrapiItem[],
  pagination?: {
    page: number;
    pageSize: number;
    pageCount: number;
    total: number;
  }
): FetchSuccessAction => ({
  type: StrapiActionTypes.FETCH_SUCCESS,
  payload: {
    modelName,
    data,
    pagination,
  },
});

export const fetchDataFailure = (modelName: string, error: string): FetchFailureAction => ({
  type: StrapiActionTypes.FETCH_FAILURE,
  payload: {
    modelName,
    error,
  },
});

export const addData = (modelName: string, data: any): AddRequestAction => ({
  type: StrapiActionTypes.ADD_REQUEST,
  payload: {
    modelName,
    data,
  },
});

export const addDataSuccess = (modelName: string, data: StrapiItem): AddSuccessAction => ({
  type: StrapiActionTypes.ADD_SUCCESS,
  payload: {
    modelName,
    data,
  },
});

export const addDataFailure = (modelName: string, error: string): AddFailureAction => ({
  type: StrapiActionTypes.ADD_FAILURE,
  payload: {
    modelName,
    error,
  },
});

export const setLastAddedId = (modelName: string, id: number | null): SetLastAddedIdAction => ({
  type: StrapiActionTypes.SET_LAST_ADDED_ID,
  payload: {
    modelName,
    id,
  },
});

export const deleteData = (modelName: string, id: string): DeleteRequestAction => ({
  type: StrapiActionTypes.DELETE_REQUEST,
  payload: {
    modelName,
    id,
  },
});

export const deleteDataSuccess = (modelName: string, id: string): DeleteSuccessAction => ({
  type: StrapiActionTypes.DELETE_SUCCESS,
  payload: {
    modelName,
    id,
  },
});

export const deleteDataFailure = (modelName: string, error: string): DeleteFailureAction => ({
  type: StrapiActionTypes.DELETE_FAILURE,
  payload: {
    modelName,
    error,
  },
});

export const setLastDocId = (modelName: string, documentId: string | null): SetLastDocIdAction => ({
  type: StrapiActionTypes.SET_LAST_DOC_ID,
  payload: {
    modelName,
    documentId,
  },
});

export const updateData = (modelName: string, documentId: string, data: any) => ({
  type: StrapiActionTypes.UPDATE_REQUEST,
  payload: { modelName, documentId, data },
});

export const updateDataSuccess = (modelName: string, data: any) => ({
  type: StrapiActionTypes.UPDATE_SUCCESS,
  payload: { modelName, data },
});

export const updateDataFailure = (modelName: string, error: string) => ({
  type: StrapiActionTypes.UPDATE_FAILURE,
  payload: { modelName, error },
});

export const clearModelData = (modelName: string) => ({
  type: 'CLEAR_MODEL_DATA',
  payload: { modelName }
});